import { CollectionModel } from '../../data-layer/collections/types';
import { CollectionPersistenceUI } from '../../ui/users/types';

export const toCollectionPersistenceUI = (model: CollectionModel): CollectionPersistenceUI => ({
    id: model.id,
    displayName: model.displayName,
    isPublic: model.isPublic,
    numberOfPosts: model.numberOfPosts,
    feedStatus: model.feedStatus,
});
